<template>
    <div class="d-flex align-center">
        <v-combobox
            ref="cboxSearch"
            @change="fuPriAlumnoSelection"
            @keyup.enter="fuSearch"
            :loading="dLoading"
            :items="dPriAlumnos"
            item-value="IdAlumno"
            item-text="AlumnoDNICodigo"
            label="Buscar por Código o DNI o Apellidos"
            style="max-width: 600px;"
            dense outlined rounded clearable hide-details>
            <template v-slot:item="{ item }">
                <v-list-item-content>
                    <v-list-item-title>{{item.Alumno}}</v-list-item-title>
                    <v-list-item-subtitle>
                        <v-icon size="20" color="blue">credit_card</v-icon>{{item.DNI}} 
                        <v-icon size="20" color="blue">code</v-icon>{{item.Codigo}}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-chip class="ma-2" :color="fuServicioInicialColor(item.priservicio.Iniciales)" outlined>{{item.priservicio.Iniciales}}</v-chip>
                </v-list-item-action>
            </template>
        </v-combobox>
        <v-btn @click="fuSearch" :loading="dLoading" class="mx-2" fab dark small color="primary"><v-icon dark>search</v-icon></v-btn>
    </div>
</template>
<script>
import gql from 'graphql-tag';
import {fuServicioInicialColor} from '@/helpers/index.js';
export default {
    name: 'PriAlumnoSearch',
    data: () => ({
        dLoading : false,
        dPriAlumnos: [],
    }),
    methods: {
        fuServicioInicialColor,
        async fuSearch() {            
            if (this.$refs.cboxSearch.internalSearch != "" && this.$refs.cboxSearch.internalSearch && this.$refs.cboxSearch.internalSearch.length >= 4 && this.$refs.cboxSearch.internalSearch.length < 40) {
                this.dLoading = true;
                try {
                    const response = await this.$apollo.query({
                        query: gql`query prialumnoBySearch($Search: String!){
                            prialumnoBySearch(Search: $Search){
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                IdServicio
                                priservicio{
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }`,
                        variables: {
                            Search: this.$refs.cboxSearch.internalSearch
                        }
                    })
                    this.dPriAlumnos = response.data.prialumnoBySearch.map(item =>{
                        return {
                            ...item,
                            AlumnoDNICodigo: `${item.Alumno} - ${item.DNI} - ${item.Codigo}`
                        }
                    })
                    if (this.dPriAlumnos.length > 0) {
                        this.$nextTick(() => {
                            this.$refs.cboxSearch.focus();
                            this.$refs.cboxSearch.isMenuActive = true; 
                        });
                    }
                    
                } catch (error) {
                    console.log(error);
                } finally {
                    this.dLoading = false
                }
            }
        },
        fuPriAlumnoSelection(item) {
            if(typeof item === 'object' && item !== null && !Array.isArray(item)){
                this.$emit('fuPriAlumnoChange', item);
            }
        },
    },
}
</script>